import { render, staticRenderFns } from "./ProjectQuickLinks.vue?vue&type=template&id=292cf758&scoped=true&"
import script from "./ProjectQuickLinks.vue?vue&type=script&lang=js&"
export * from "./ProjectQuickLinks.vue?vue&type=script&lang=js&"
import style0 from "./ProjectQuickLinks.vue?vue&type=style&index=0&id=292cf758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292cf758",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('292cf758')) {
      api.createRecord('292cf758', component.options)
    } else {
      api.reload('292cf758', component.options)
    }
    module.hot.accept("./ProjectQuickLinks.vue?vue&type=template&id=292cf758&scoped=true&", function () {
      api.rerender('292cf758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/information/ProjectQuickLinks.vue"
export default component.exports